import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import HelpGuide from './HelpGuide';
import './Header.css';

function Header() {
  const { user, logout } = useAuth();
  const { language, setLanguage, t } = useLanguage();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="header">
      <div className="header-left">
        <div className="header-logo">
          <img src={`${process.env.PUBLIC_URL}/logo-olelarsen-white.png`} alt="Ole Larsen" className="header-logo-image" />
          <span className="logo-subtitle">FAST <span className="track-text">TRACK</span></span>
        </div>
        <div className="lang-selector">
          <span
            className={language === 'da' ? 'active' : ''}
            onClick={() => setLanguage('da')}
            style={{ cursor: 'pointer' }}
          >
            Dansk
          </span>
          <span className="divider">|</span>
          <span
            className={language === 'en' ? 'active' : ''}
            onClick={() => setLanguage('en')}
            style={{ cursor: 'pointer' }}
          >
            English
          </span>
        </div>
      </div>

      <div className="header-right">
        <div className="welcome-info">
          <span className="welcome-customer">{user?.customer_name || user?.organization_name}</span>
          <span className="welcome-greeting">{t('welcome')}, {user?.name}</span>
        </div>

        <button className="need-help-btn" onClick={() => setShowHelp(true)}>
          {t('needHelp')}
          <span className="help-icon">?</span>
        </button>

        {showHelp && <HelpGuide onClose={() => setShowHelp(false)} />}

        <div className="user-dropdown" ref={dropdownRef}>
          <button
            className="user-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {user?.name}
            <span className="dropdown-arrow">▼</span>
          </button>

          {showDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-item user-info">
                <strong>{user?.name}</strong>
                <span>{user?.email}</span>
              </div>
              <button className="dropdown-item logout-btn" onClick={logout}>
                {t('logOut')}
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
